import $ from 'jquery';
export default function int_tabbed() {
	$('.tabulation-item_link').on('click', function(evt) {
		if(!$(this).hasClass("only-link")){
		
			evt.preventDefault();
		
			$('.tabulation-item_link').removeClass('active');
			$(this).addClass('active');
			var sel = this.getAttribute('data-toggle-target');
			$('.modules-tabbed-content_tabs-content').removeClass('active').filter(sel).addClass('active');
		}
	});
}